{
  "contract.agreement.addNote.description": "Der er behov for individuel prisfastsættelse af en medarbejder i Finans. Her kan tilføjes en note, som videregives til den ansvarlige finansmedarbejder.",
  "contract.agreement.allocation.remaining.label": "Resterende $t(common:allocation)",
  "contract.agreement.awaitingSendAppendix": "Tillæg til låneaftale er endnu ikke afsendt",
  "contract.agreement.awaitingSendLoan": "Låneaftalen er endnu ikke afsendt",
  "contract.agreement.compensationFixed.success": "Kompensationsbeløb fastsat",
  "contract.agreement.completeNewLoan": "Registrer aftale",
  "contract.agreement.completeRedemption": "Gennemfør indfrielse",
  "contract.agreement.differsFromDecisions.description": "Lav ny beregning eller ret sagsinformationer",
  "contract.agreement.differsFromDecisions.title": "Beregningen fejler på {{ givenValues }}",
  "contract.agreement.exceedsAllocation.description": "Aftalen kan ikke indgås, fordi den angivne hovedstol overstiger den resterende bevilling. Gå tilbage og lav en ny beregning.",
  "contract.agreement.exceedsAllocation.title": "Hovedstolen overstiger bevillingsstørrelsen",
  "contract.agreement.exceedsAllocationAndPeriod.description": "Aftalen kan ikke indgås, fordi den angivne hovedstol og løbetid overstiger bevillingen. Gå tilbage og lav en ny beregning.",
  "contract.agreement.exceedsAllocationAndPeriod.title": "$t(common:principalAmount_specific) og $t(common:loanPeriod_specific) overstiger $t(common:allocation_specific)",
  "contract.agreement.exceedsLoanPeriod.description": "Aftalen kan ikke indgås, fordi den angivne løbetid overstiger bevillingens maksimale løbetid. Gå tilbage og lav en ny beregning.",
  "contract.agreement.exceedsLoanPeriod.title": "Løbetiden overstiger bevillingens maksimale løbetid",
  "contract.agreement.validation.title": "Beregning kan ikke opdateres",
  "contract.agreement.validation.generic": "Aftalen kan ikke registreres. Redigér beregningen og indhent herefter ny godkendelse fra kunden.",
  "contract.agreement.validation.firstInterestDateExceeded.noDate": "Dato for første rentebetaling er overskredet",
  "contract.agreement.validation.firstInterestDateExceeded.withDate": "Dato for første rentebetaling den {{date}} er overskredet",
  "contract.agreement.generation.success": "Aftaledokument genereret",
  "contract.agreement.loanPeriod.decided.label": "Besluttet $t(common:loanPeriod)",
  "contract.agreement.loanPeriod.given.label": "Angivet $t(common:loanPeriod)",
  "contract.agreement.loanPeriod.max.label": "Maksimal $t(common:loanPeriod)",
  "contract.agreement.notifyFinance.success": "Sagen er overdraget til Finans",
  "contract.agreement.principalAmount.decided.label": "Besluttet $t(common:principalAmount)",
  "contract.agreement.principalAmount.given.label": "Angivet $t(common:principalAmount)",
  "contract.agreement.productType.decided.label": "Besluttet $t(common:productType)",
  "contract.agreement.productType.given.label": "Angivet $t(common:productType)",
  "contract.agreement.sidePanel.newLoan.description": "Beregningen skal opdateres inden gennemførelse for at sikre aktuelle priser.",
  "contract.agreement.sidePanel.newLoan.title": "Registrering af nyt udlån",
  "contract.agreement.sidePanel.newInterestAgreement.description": "Beregningen skal opdateres inden gennemførelse for at sikre aktuelle priser.",
  "contract.agreement.sidePanel.newInterestAgreement.title": "Registrering af ny renteaftale",
  "contract.agreement.sidePanel.recipient.title": "$t(common:recipient_one) (kontaktperson)",
  "contract.agreement.sidePanel.redemption.description": "Kompensationsbeløbet skal opdateres inden gennemførelse for at sikre aktuelle priser.",
  "contract.agreement.sidePanel.title": "Gennemførelse af {{changeMethod}}",
  "contract.agreement.startAgreementExecution.success": "{{changeMethod}} er gennemført",
  "contract.agreement.title": "Aftaleindgåelse",
  "contract.agreement.validateResponse": "Valider kundesvar",
  "contract.calculations.none": "Beregninger er endnu ikke udført",
  "contract.caseInformation.accountNo": "Konto nr.:",
  "contract.caseInformation.administrativeContact": "Kontaktperson vedr. administrationen",
  "contract.caseInformation.authorizedSigners": "Vælg underskrivere",
  "contract.caseInformation.bsCustomerNumber": "BS-Kunde nr.",
  "contract.caseInformation.bsNumber": "BS nr.",
  "contract.caseInformation.allocation.byLawMissing": "Vedtægterne mangler og skal gemmes på bevillingssagen.",
  "contract.caseInformation.eventCase.byLawMissing": "Vedtægterne mangler og skal gemmes på sagen.",
  "contract.caseInformation.chooseAccount": "Vælg konto",
  "contract.caseInformation.chooseContact": "Vælg kontaktperson",
  "contract.caseInformation.chooseFromList": "Vælg fra listen",
  "contract.caseInformation.chooseOneFromList": "Vælg én fra listen",
  "contract.caseInformation.contactPersonEmail": "Kontakt e-mail",
  "contract.caseInformation.ContractDraftInfo": "Oplysninger til låneaftalen",
  "contract.caseInformation.ContractDraftInfo.read": "Se oplysninger",
  "contract.caseInformation.ContractDraftInfo.write": "Udfyld oplysninger",
  "contract.caseInformation.CreditMandates": "Fuldmagtshavere til byggekredit",
  "contract.caseInformation.CreditMandates.creditMandate_one": "Fuldmægtig",
  "contract.caseInformation.CreditMandates.creditMandate_other": "Fuldmagtshavere",
  "contract.caseInformation.CreditMandates.missingApproval": "Fuldmagtshavere mangler at godkendes.",
  "contract.caseInformation.CreditMandates.noMandates": "Der er ikke oprettet nogle kontaktpersoner.",
  "contract.caseInformation.CreditMandates.read": "Se fuldmagtshavere",
  "contract.caseInformation.CreditMandates.write": "Vælg fuldmagtshavere",
  "contract.caseInformation.customer.authorizedSignersDescription": "Vælg de tegningsberettigede fra listen, der skal underskrive gældsbrevet, så tegningsreglerne opfyldes.\nDe tegningsberettigede skal være oprettet i Signaturgruppen og være logget ind på Kundeportalen, før de vises i listen.",
  "contract.caseInformation.CustomerByLaws": "Kundens tegningsregler",
  "contract.caseInformation.CustomerByLaws.read": "Se underskrivere",
  "contract.caseInformation.CustomerByLaws.write": "Vælg underskrivere",
  "contract.caseInformation.CustomerByLaws.fileAttach.title": "Vedhæft vedtægter",
  "contract.caseInformation.CustomerByLaws.fileAttach.description": "Vælg kundens seneste vedtægter, som indeholder de gældende tegningsregler.",
  "contract.caseInformation.debGroupNumber": "DEB gr. nr.",
  "contract.caseInformation.eanEmailDescription": "Bruges såfremt kunden ikke har EAN.",
  "contract.caseInformation.eanEmailPastDescription": "Er benyttet da kunden ikke har EAN. ",
  "contract.caseInformation.eanNotification": "EAN",
  "contract.caseInformation.eanNotification.input.label": "EAN-nummer",
  "contract.caseInformation.FinancialActivity": "Økonomisk aktivitet",
  "contract.caseInformation.FinancialActivity.read": "Se branchekode",
  "contract.caseInformation.FinancialActivity.write": "Vælg branchekode",
  "contract.caseInformation.fullName": "Fulde navn",
  "contract.caseInformation.Guarantee": "Garanter",
  "contract.caseInformation.Guarantee.G": "Garantistillelse",
  "contract.caseInformation.Guarantee.I": "Interessenter",
  "contract.caseInformation.Guarantee.read": "Se oplysninger",
  "contract.caseInformation.Guarantee.write": "Udfyld oplysninger",
  "contract.caseInformation.guaranteeType": "Garantitype",
  "contract.caseInformation.guarantor.authorizedSignersDescription": "For at opfylde tegningsreglerne skal du vælge de tegningsberettigede fra listen nedenfor, som skal underskrive gældsbrevet.\nDe tegningsberettigede skal være oprettet i Signaturgruppen og være logget ind på Mit KommuneKredit, før de vises med navn på listen.",
  "contract.caseInformation.GuarantorByLaws": "Garantistillers tegningsregler",
  "contract.caseInformation.GuarantorByLaws.read": "Se underskrivere",
  "contract.caseInformation.GuarantorByLaws.write": "Vælg underskrivere",
  "contract.caseInformation.GuarantorByLaws.subheading": "Her kan du angive, hvilke tegningsberettigede personer der skal underskrive på vegne af garantistilleren. De tegningsberettigede skal være oprettet i Signaturgruppen og være logget ind på Mit KommuneKredit, før deres navne vises på listen.",
  "contract.caseInformation.industryCode": "Branchekode",
  "contract.caseInformation.jointLiability": "Solidarisk hæftelse",
  "contract.caseInformation.Kyc": "KYC",
  "contract.caseInformation.Kyc.read": "Se Kyc",
  "contract.caseInformation.Kyc.write": "Igangsæt KYC",
  "contract.caseInformation.kycHeading": "Igangsæt KYC",
  "contract.caseInformation.kycSubheading": "Know Your Customer",
  "contract.caseInformation.loanDecisions.customer": "Har kunden truffet beslutning om lån?",
  "contract.caseInformation.loanDecisions.description.customer": "Udfyld felterne, hvis kunden har truffet beslutning om lånets specifikke løbetid, hovedstol eller produkttype.",
  "contract.caseInformation.loanDecisions.description.guarantor": "Udfyld felterne, hvis garantistiller har truffet beslutning om lånets specifikke løbetid, hovedstol eller produkttype.",
  "contract.caseInformation.loanDecisions.guarantor": "Har garantistiller truffet beslutning om lån?",
  "contract.caseInformation.loanPeriod.placeholder": "Angiv løbetid",
  "contract.caseInformation.nemKonto.title": "Udbetaling til NemKonto",
  "contract.caseInformation.paymentAccount": "Udbetalingskonto",
  "contract.caseInformation.paymentAdvise": "Advisering af indbetaling",
  "contract.caseInformation.paymentAdviseLocked": "Betalingsadvisering",
  "contract.caseInformation.PaymentInfo": "Betalingsoplysninger",
  "contract.caseInformation.PaymentInfo.read": "Se oplysninger",
  "contract.caseInformation.PaymentInfo.write": "Udfyld oplysninger",
  "contract.caseInformation.paymentService": "Betalingsservice",
  "contract.caseInformation.paymentServiceDescription": "Kunden skal selv oprette betalingsserviceaftale i egen netbank med følgende oplysninger:",
  "contract.caseInformation.paymentServiceError": "Betalingsservice kan ikke vælges for Byggekreditter. Vælg derfor en anden adviseringsmetode.",
  "contract.caseInformation.paymentServiceTooltip": "Betalingsservice kan ikke vælges for Byggekreditter",
  "contract.caseInformation.pdf": "PDF",
  "contract.caseInformation.pdfTooltip": "Anvendes når kunden ikke har mulighed for hverken EAN eller Betalingsservice. Advisering i PDF format fremsendes på kontaktpersons mail",
  "contract.caseInformation.principalAmount.placeholder": "Angiv hovedstol",
  "contract.caseInformation.proRataLiability": "Pro rata hæftelse",
  "contract.caseInformation.regNo": "Reg. nr.:",
  "contract.caseInformation.searchIndustryCode": "Søg efter branchekoden",
  "contract.caseInformation.selectGuarantors": "Vælg/fravælg garantistiller",
  "contract.caseInformation.selectStakeholders": "Vælg/fravælg interessenter",
  "contract.caseInformation.signers.EntitledSigner": "Tegningsberettiget",
  "contract.caseInformation.signers.undefined": "Udefineret",
  "contract.caseInformation.signersMissing": "Den tegningsberettigede for kunden er endnu ikke oprettet i Signaturgruppen.",
  "contract.caseInformation.signingRules": "Tegningsregler",
  "contract.caseInformation.stakeholders": "Interessenter",
  "contract.caseInformation.startBody": "For at kunne indgå en aftale, er det nødvendigt at gennemføre KYC-processen.",
  "contract.caseInformation.sustainableFinancing": "Bæredygtig finansiering?",
  "contract.caseInformation.title": "Sagsinformationer",
  "contract.caseInformation.optional": "Valgfri",
  "contract.caseInformation.useCustomerIndustryCode": "Brug kundens branchekode",
  "contract.caseInformation.viaEan": "via EAN advisering",
  "contract.caseInformation.viaMail": "via mail",
  "contract.caseInformation.viaPaymentService": "via betalingsservice",
  "contract.cases.title": "Sager",
  "contract.disbursement.newLoan.awaiting.message": "Udbetalingen vil ske til kundens NemKonto",
  "contract.disbursement.newLoan.awaiting.title": "Låneaftalen er endnu ikke klar til udbetaling.",
  "contract.editCalculation.modal.newLoan.description": "Du er ved at redigere i aftaleoplysningerne. Ved redigering sendes du tilbage til beregningsfasen.",
  "contract.editCalculation.modal.newLoan.title": "Ændring af oplysninger annullerer aftalen",
  "contract.editCalculation.modal.primaryAction": "Gå til beregning",
  "contract.editCalculation.modal.toast": "Tilbudsbrev annulleret",
  "contract.editCalculation.modal.redemption.description": "Du er ved at redigere i afdragsoplysningerne. Ved redigering sendes du tilbage til beregningsfasen, og det aktuelle tillæg annulleres.",
  "contract.editCalculation.modal.redemption.title": "Ændring af afdragsoplysninger annullerer tillæg til aftale",
  "contract.execution.fullRedemption.completedMessage": "Fuld indfrielse med nedenstående detaljer er nu registreret i kildesystemer og sagen afsluttes.",
  "contract.execution.newInterestAgreement.accordion.title": "Eksekvering og registrering af ny renteaftale",
  "contract.execution.newInterestAgreement.awaiting": "Renteaftalen er endnu ikke eksekveret",
  "contract.execution.newInterestAgreement.completedMessage": "Den nye renteaftale med nedenstående detaljer er nu registreret i kildesystemerne. Afventer underskrift af aftaletillæg.",
  "contract.execution.newLoan.accordion.title": "Eksekvering og registrering af låneaftale",
  "contract.execution.newLoan.awaiting": "Låneaftalen er endnu ikke eksekveret",
  "contract.execution.newLoan.completedMessage": "Det nye lån med nedenstående detaljer er nu registreret i kildesystemerne. Afventer Underskrift af gældsbrev.",
  "contract.execution.partialRedemption.accordion.title": "Eksekvering og registrering af ekstraordinært afdrag",
  "contract.execution.redemption.accordion.title": "Eksekvering og registrering af indfrielse",
  "contract.execution.redemption.awaiting": "Indfrielse er endnu ikke eksekveret",
  "contract.execution.redemption.completedMessage": "Det ekstraordinære afdrag med nedenstående detaljer er nu registreret i kildesystemer og sagen afsluttes.",
  "contract.execution.title": "Eksekvering",
  "contract.fillInformation": "Udfyld oplysninger",
  "contract.generation.modal.attachments": "Vedhæftede dokumenter",
  "contract.generation.modal.message": "Indgåelse af aftale: {{ eventDescription }} - låneaftale {{ contractId }} ({{ caseId }})",
  "contract.generation.modal.recipientTitle": "Besked til modtager",
  "contract.generation.modal.submit": "Send tillæg",
  "contract.generation.newInterestAgreement.sidePanel.title": "Afsendelse af tilbud om renteaftale",
  "contract.generation.newInterestAgreement.send": "Send tilbud om renteaftale",
  "contract.generation.newInterestAgreement.send.short": "Send tilbud",
  "contract.generation.newInterestAgreement.notGenerated": "Tilbud om renteaftale er ikke dannet",
  "contract.generation.newLoan.notGenerated": "Låneaftale er ikke dannet",
  "contract.generation.newLoan.send": "Send låneaftale",
  "contract.generation.newLoan.sidePanel.title": "Afsendelse af låneaftale",
  "contract.generation.redemption.notGenerated": "Tillæg til låneaftale er ikke dannet",
  "contract.generation.redemption.send": "Send tillæg til låneaftale",
  "contract.generation.redemption.sidePanel.title": "Afsendelse af tillæg til låneaftale",
  "contract.generation.success": "Tillæg til aftale er afsendt",
  "contract.generation.newInterestAgreement.success": "Tilbud om renteaftale afsendt",
  "contract.generation.newLoan.success": "Lånetilbud afsendt",
  "contract.generation.title": "Aftalegenerering",
  "contract.overview.title": "Oversigt",
  "contract.priceSetting.accordion.rateSetting.description": "Der er behov for individuel prisfastsættelse. Renten skal derfor individuelt prisfastsættes af en medarbejder i Finans.",
  "contract.priceSetting.accordion.rateSetting.input.label": "$t(data:data.fixedInterestRate)",
  "contract.priceSetting.accordion.rateSetting.title": "Fastsættelse af rentesats",
  "contract.priceSetting.accordion.redemption.description": "Der er behov for individuel prisfastsættelse af en medarbejder i Finans.",
  "contract.priceSetting.accordion.redemption.input.label": "Individuelt fastsat kompensationsbeløb",
  "contract.priceSetting.accordion.redemption.title": "Fastsættelse af kompensationsbeløb",
  "contract.priceSetting.compensation.completedBody": "Kompensationsbeløbet er fastsat og afdraget registreret.",
  "contract.priceSetting.compensation.input.error": "Der skal fastsættes et kompensationsbeløb",
  "contract.priceSetting.compensation.variance.modal.body": "Det indtastede kompensationsbeløb varrierer med mere end {{ percentage }} fra det beregnede kompensationsbeløb. Er du sikker på, at du vil gennemføre?",
  "contract.priceSetting.compensation.variance.modal.title": "Er det indtastede beløb korrekt?",
  "contract.priceSetting.completedTitle": "Prisfastsættelsen er gennemført",
  "contract.priceSetting.cta.close": "Luk side",
  "contract.priceSetting.cta.reject": "Afvis anmodning",
  "contract.priceSetting.cta.setCompensation": "Fastsæt kompensation",
  "contract.priceSetting.cta.setRate": "Fastsæt rentesats",
  "contract.priceSetting.input.compensationLabel": "Individuelt fastsat kompensationsbeløb",
  "contract.priceSetting.input.compensationTooltip": "Eksklusiv vedhængende rente",
  "contract.priceSetting.input.rateLabel": "$t(data:data.fixedInterestRate)",
  "contract.priceSetting.message": "Der er behov for individuel prisfastsættelse af en medarbejder i Finans.",
  "contract.priceSetting.messageToFinancialCounterpart": "Besked til Finansiel modpart",
  "contract.priceSetting.modal.body": "Ved afslag overdrages sagen til den ansvarlige kundemedarbejder, der enten kan redigere i beregningsgrundlaget eller alternativt afslutte sagen.",
  "contract.priceSetting.modal.cta.primary": "Afvis",
  "contract.priceSetting.modal.input.label": "Angiv årsag til afvisning",
  "contract.priceSetting.modal.input.placeholder": "Skriv årsag",
  "contract.priceSetting.modal.title": "Du er ved at afvise anmodningen",
  "contract.priceSetting.newInterestAgreement.notConfirmed": "Tilbud vedrørende ny renteaftale er endnu ikke bekræftet",
  "contract.priceSetting.newLoan.notConfirmed": "Låneaftalen er endnu ikke bekræftet",
  "contract.priceSetting.noAddendum": "Tillæg til låneaftale er endnu ikke bekræftet",
  "contract.priceSetting.rate.completedBody": "Renten er fastsat og lånet er registreret.",
  "contract.priceSetting.rate.input.error": "Der skal fastsættes en rentesats",
  "contract.priceSetting.rate.variance.modal.body": "Den indtastede rente varierer med mere end {{ bp }} bp fra den accepterede rente. \n\nBekræft at du vil gennemføre.",
  "contract.priceSetting.rate.variance.modal.title": "Er den indtastede rente korret?",
  "contract.priceSetting.reject.success": "Indfrielse afvist",
  "contract.priceSetting.rejected": "{{ employee }} har afvist andmodningen",
  "contract.priceSetting.title": "Individuel prisfastsættelse",
  "contract.seeInformation": "Se oplysninger",
  "contract.signing.agreementDate": "Aftaledato",
  "contract.signing.Company": "Kunde",
  "contract.signing.completedMessage": "Dokumentet er underskrevet og arkiveret",
  "contract.signing.customerAndGuarantor": "Kunde og Garantistiller",
  "contract.signing.deadline": "Frist for underskrifter",
  "contract.signing.Guarantor": "Garantistiller",
  "contract.signing.hasSigned": "har underskrevet",
  "contract.signing.nextReminder": "Næste påmindelse",
  "contract.signing.payoutDate": "Udbetalingsdato",
  "contract.signing.pendingMessage": "Gældsbrevet er endnu ikke klar til underskrift",
  "loan.agreementDate": "Aftaledato",
  "loan.amortizationProfile": "Afdragsprofil",
  "loan.availableAmount": "Rådighedsbeløb",
  "loan.borrower": "Låntager",
  "loan.bossInfoId": "BOSS-Info Nr.",
  "loan.bossInfoProjectName": "BOSS-Info Projekt",
  "loan.contractInformation": "Aftaleoplysninger",
  "loan.contractNumber": "Aftalenummer",
  "loan.createCase": "Opret sag",
  "loan.createNew": "Nyt udlån",
  "loan.credit.startDate": "Startdato",
  "loan.creditDraw": "Kredittræk",
  "loan.creditMax": "Kreditmaksimum",
  "loan.creditMaximum": "Kreditmaksimum",
  "loan.creditPostings": "Posteringsoversigt",
  "loan.currentNotionalAmount": "Aktuel restgæld",
  "loan.currentRate": "Aktuel rentesats",
  "loan.currentRate.spread.cibor.tooltip": "Inkl. KK tillæg",
  "loan.currentRate.tooltip": "Inkl. KK tillæg",
  "loan.customerInformedInterestRate": "Kundeoplyst rentesats",
  "loan.customerSwap": "Renteswap",
  "loan.daysUntilExpiry": "{{time}} til udløb",
  "loan.economicActivity": "Økonomisk aktivitet",
  "loan.effectiveRate": "Effektiv rentesats",
  "loan.expired": "Udløbet {{date, date}}",
  "loan.firstInstallmentDate": "Første afdragstermin",
  "loan.firstRateDate": "Første rentetermin",
  "loan.firstRatePaymentDate": "Første rentebetalingsdato",
  "loan.guarantor": "Garantistiller",
  "loan.guarantor_other": "Garantistillere",
  "loan.interestConditionExpirationWarning": "Udløb af renteaftale: {{date}}",
  "loan.interestConditionStartDate": "Start renteaftale",
  "loan.interestConditionExpiryDate": "Udløb renteaftale",
  "loan.interestAgreementExpiryWarning": "Renteaftale udløber om {{days}} dage og kræver fornyelse",
  "loan.interestAgreementExpiredWarning": "Renteaftale er udløbet og kræver fornyelse",
  "loan.interestConditionExpired": "Overskredet",
  "loan.interestRate": "Rentesats",
  "loan.interestRatePlusSpreadDate": "Samlet indikativ variabel rente pr. {{ date, date }}",
  "loan.interestType": "Rentetype",
  "loan.lastRatePaymentDate": "Sidste rentebetalingsdato",
  "loan.latestRateSetting": "Fastsat pr. {{ date, date }}",
  "loan.latestRateSetting.notAvailable": "Fastsat dato ikke tilgængelig",
  "loan.liabilityAmount": "Garantibeløb",
  "loan.liabilityType": "Garantitype",
  "loan.loanInformation": "Aftaleoplysninger",
  "loan.loanPeriod": "løbetid",
  "loan.loanPurpose": "Låneformål",
  "loan.masterInformation": "Stamoplysninger",
  "loan.maturityDate": "Udløbsdato",
  "loan.maturityDate.loan": "Udløbsdato lån",
  "loan.maturityDate_specific": "Lånets udløbsdato",
  "loan.nextFixingDate": "Næste rentetilskrivning",
  "loan.nextInterestAccrual": "Næste rentetermin",
  "loan.nextPaymentDate": "Næste betaling",
  "loan.nextRateSetting": "Næste rentefastsættelse",
  "loan.nextValueDate": "Næste termin",
  "loan.noActiveCases": "Ingen aktive sager",
  "loan.nonAccruedInterest": "Ikke tilskrevne renter",
  "loan.nonAccruedInterest.credit": "Ikke tilskrevne renter pr. dd.",
  "loan.nonAccruedInterest.tooltip": "Fra seneste rentetilskrivning til sags dato",
  "loan.noOutstandingPayments": "Ingen udestående betalinger",
  "loan.notionalAmountLCY": "Restgæld",
  "loan.notionalAmountLCY.tooltip": "Restgæld pr. dags dato",
  "loan.originalLoanPeriod": "Oprindelig $t(common:loanPeriod)",
  "loan.paymentOverview": "Ydelsesoversigt",
  "loan.priceInformation": "Prisoplysninger",
  "loan.principalAmount": "Hovedstol",
  "loan.principalAmount.credit": "Kreditmaksimum",
  "loan.product": "$t(common:productType)",
  "loan.rateAndInstallmentFrequency": "Rente- og afdragsfrekvens",
  "loan.rateFrequency": "Rentefrekvens",
  "loan.rateOnDate": "Aktuel rentesats",
  "loan.ratesAndPayments": "Renter og afdrag",
  "loan.redemptionValue": "Indfrielsesværdi (EST.)",
  "loan.remainingLoanPeriod": "Restløbetid",
  "loan.seeAllCases": "Se alle sager",
  "loan.spread": "KK tillæg",
  "loan.spread.cibor": "- Heraf KK tillæg",
  "loan.spread.cibor.copy": "- heraf KK tillæg",
  "loan.spreadCommitment": "KK tillæg binding",
  "loan.spreadDate": "Tillæg pr. {{ date, date }}",
  "loan.startDate": "Udbetalingsdato",
  "loan.sustainableFramework": "Bæredygtig finansiering",
  "loan.type": "Aftaletype",
  "portfolioInformation.accountingArea": "AccountingArea",
  "portfolioInformation.accountingGroup": "accountingGroup",
  "portfolioInformation.instrumentId": "InstrumentID",
  "portfolioInformation.title": "Porteføljeoplysninger",
  "swap_one": "swap",
  "swap_other": "swaps",
  "test": "test",
  "test2": "test2"
}
